const MIN_DI = 40000;
const MIN_APD_FOR_20 = 50000;
const MIN_APD_ABOVE_20 = 70000;
const ATD_THRESHOLD = 20;

interface ATDOptionsResult {
    availableOptions: number[];
    disabledOptions: number[];
}

export function getAvailableATDOptions(diValue: number, apdValue: number, allOptions: number[]): ATDOptionsResult {
    let availableOptions: number[];

    if (diValue < MIN_DI) {
        availableOptions = allOptions.filter(opt => opt < ATD_THRESHOLD);
    } else if (diValue >= MIN_DI && apdValue >= MIN_APD_FOR_20 && apdValue < MIN_APD_ABOVE_20) {
        availableOptions = allOptions.filter(opt => opt <= ATD_THRESHOLD);
    } else if (diValue >= MIN_DI && apdValue >= MIN_APD_ABOVE_20) {
        availableOptions = allOptions;
    } else {
        availableOptions = allOptions.filter(opt => opt < ATD_THRESHOLD);
    }

    const disabledOptions = allOptions.filter(opt => !availableOptions.includes(opt));

    return {
        availableOptions,
        disabledOptions,
    };
}
